module.exports = __webpack_public_path__ + "img/app-access.5979682c.svg";